import './App.css';
import Main from 'components/upload-image/Main.jsx';

function App() {
  return (
    <div className="px-2">
      <Main />
    </div>
  );
}

export default App;
